<template>
  <main class="w-100">
    <b-row id="dashboar-home" v-if="!enableDashboardBuilder">
      <b-col cols="12" class="wrapper-content">
        <b-row class="wrapper-title-page">
          <b-col cols="10" class="d-flex  align-items-center">
            <h4 class="page-title">{{ title }}</h4>
          </b-col>
          <b-col cols="2" class="d-flex justify-content-end align-items-center">
            <LmBtnUpdateContent />
          </b-col>
        </b-row>
        <b-row>
          <component
            v-for="(componentData, index) in dashItems"
            :key="index"
            :is="componentData.component"
            v-bind="componentData.prop"
            :chart-data="componentData.chartData"
            :chart-option="componentData.chartOption"
            :class="{'lm-loader': componentData.component.startsWith('LmChart') ? loading : false }"
            :showHeaderTable="true"
            :hideHeadersBelowRows="true"
          />
        </b-row>
      </b-col>
    </b-row>

    <div class="px-4 h-100" v-if="enableDashboardBuilder">
      <template v-if="!isLoading">
        <LmButton
          v-if="!disableDashboardBuilderCreation"
          class="d-flex justify-content-end sticky-top"
          style="top: 2em; z-index: 1;"
          :value="!isOnCustomizationMode ? 'Editar Dashboard' : 'Guardar cambios'"
          :buttonClass="!isOnCustomizationMode ? 'btn-primary' : 'btn-success'"
          :icon="isOnCustomizationMode ? 'save' : 'wrench'"
          @click="onSaveDashboard"
        />

        <LmSvgIcon
          v-if="!myWidgets.length && !isOnCustomizationMode"
          style="height: calc(100% - 35px - 1.5rem); padding-bottom: calc((35px + 1.5rem) * 2);"
          wrapperClass="d-flex h-100 justify-content-center align-items-center flex-column"
          width="18em"
          icon="LmDashboardIcon"
          text="Crea tu propio Dashboard"
        />

        <draggable
          class="row"
          animation="150"
          handle=".handle"
          v-model="myWidgets"
          @start="drag=true"
          @end="drag=false"
          :sort="isOnCustomizationMode"
        >
          <LmWidget
            v-for="(widget, index) of myWidgets"
            :class="[isOnCustomizationMode ? 'handle' : '']"
            :key="widget.render.id"
            :widget="widget"
            :isOnCustomizationMode="isOnCustomizationMode"
            @onWidgetRemove="onWidgetRemove(index)"
            @onWidgetCustomizationChange="onWidgetCustomizationChange($event, index)"
          />
          <b-col cols="3" v-if="isOnCustomizationMode" class="my-4">
            <div class="bg-light p-4 shadow">
              <h4>Nuevo widget</h4>
              <p>Agrega un nuevo widget al dashboard</p>
              <LmTreeSelect
                label="Formato"
                :options="widgetFormatOptions"
                v-model="widgetFormat"
                @input="newWidget = null"
              />
              <LmTextInput
                label="Título del grupo"
                placeholder="Escribe un título para el grupo"
                v-model="widgetGroupLabel"
                v-if="widgetFormat.id === 'group'"
              />
              <LmTreeSelect
                label="Widgets"
                :options="widgetsOptions"
                v-model="newWidget"
                :multiple="widgetFormat.id === 'group'"
              />
              <LmButton
                :disabled="disableAddWidgetButton"
                type="button"
                size="sm"
                buttonClass="btn-primary"
                :value="$t('add')"
                @click="onAddWidget"
              />
            </div>
          </b-col>
        </draggable>
      </template>
      <!-- loading state -->
      <div class="p-4 w-100" v-else>
        <b-skeleton class="mb-4 w-50" type="input"></b-skeleton>
        <b-row class="mb-4">
          <b-col><b-skeleton-img height="180px"></b-skeleton-img></b-col>
          <b-col><b-skeleton-img height="180px"></b-skeleton-img></b-col>
          <b-col><b-skeleton-img height="180px"></b-skeleton-img></b-col>
          <b-col><b-skeleton-img height="180px"></b-skeleton-img></b-col>
        </b-row>
        <b-skeleton-table
          :rows="8"
          :columns="4"
          :table-props="{ bordered: false, striped: true }"
        ></b-skeleton-table>
      </div>
    </div>
  </main>
</template>

<script>
// import apiSettings from '@/api/settings'
import commonsApi from '@/api/commons'
import { mapState, mapActions } from 'vuex'
import LmBtnUpdateContent from '@/components/LmBtnUpdateContent.vue'
import draggable from 'vuedraggable'
import LmButton from '@/components/form/elements/LmButton.vue'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect.vue'
import LmTextInput from '@/components/form/elements/LmTextInput.vue'

import LmWidget from '@/components/LmWidget'

import lmToasts from '@/mixins/lmToasts.js'

import { getWidgetCustomizationProps } from '@/helpers/LmWidgets'

export default {
  mixins: [lmToasts],
  data () {
    return {
      enableDashboardBuilder: process?.env?.VUE_APP_ENABLE_DASHBOARDBUILDER === 'true',
      // Agregamos esto por una necesidad puntual del cliente hasta tanto esté
      // la mejora definitiva que permite limitar la visibilidad de los widgets
      // hoy por defecto son todos públicos.
      // De referencia:
      // - https://app.clickup.com/t/30288pr
      // - https://app.clickup.com/t/30288cm
      disableDashboardBuilderCreation: process?.env?.VUE_APP_DISABLE_DASHBOARDBUILDER_CREATION === 'yes',
      title: '',
      isOnCustomizationMode: false,
      myDashboardId: '',
      myWidgets: [],
      widgets: [],
      newWidget: null,
      widgetFormat: { id: 'single', name: 'Individual' },
      widgetGroupLabel: '',
      isLoading: false
    }
  },
  computed: {
    ...mapState('settings', ['dashItems', 'loading']),
    widgetFormatOptions () {
      return [
        { id: 'single', name: 'Individual' },
        { id: 'group', name: 'Grupo' }
      ]
    },
    disableAddWidgetButton () {
      return !!(!this.widgetFormat || !this.newWidget || (Array.isArray(this.newWidget) && !this.newWidget.length))
    },
    widgetsOptions () {
      return this.widgets.map(el => {
        return {
          id: el.id,
          name: el.name
        }
      })
    }
  },
  components: {
    LmBtnUpdateContent,
    draggable,
    LmButton,
    LmTreeSelect,
    LmWidget,
    LmTextInput
  },
  methods: {
    ...mapActions('settings', ['getDashSettings']),
    async createDashboard () {
      try {
        const res = await commonsApi.axiosPostWrapper('/dashboardbuilder/', {
          name: 'Mi nuevo dashboard'
        })
        this.myDashboardId = res.data?._id
      } catch (error) {
        console.log(error)
      }
    },
    mapWidgetProperties (event) {
      const widget = this.widgets.find(el => el.id === event.id)
      widget.customization = getWidgetCustomizationProps(widget.component)
      widget.customization.size = Math.max.apply(null, widget?.properties?.sizes) || 12
      return widget
    },
    onAddWidget () {
      const widget = {
        label: this.widgetGroupLabel || null,
        type: this.widgetFormat.id,
        render: null
      }
      if (this.widgetFormat.id === 'group') {
        widget.render = this.newWidget.map(el => {
          return this.mapWidgetProperties(el)
        })
      } else {
        widget.render = this.mapWidgetProperties(this.newWidget)
      }

      this.myWidgets.push(widget)
      this.newWidget = null
      this.widgetGroupLabel = ''
    },
    onWidgetRemove (index) {
      this.myWidgets.splice(index, 1)
    },
    async onWidgetCustomizationChange (event, index) {
      this.myWidgets[index].render.customization = Object.assign(this.myWidgets[index].render.customization, event)
    },
    async onSaveDashboard () {
      this.isOnCustomizationMode = !this.isOnCustomizationMode
      if (!this.isOnCustomizationMode) {
        try {
          if (!this.myDashboardId) {
            await this.createDashboard()
          }
          await commonsApi.axiosPutWrapper(`/dashboardbuilder/${this.myDashboardId}`, {
            widgets: this.myWidgets
          })
          this.lmToastSuccessMessage(`Se guardaron correctamente los cambios de tu dashboard.`, 'Se guardó exitosamente')
        } catch (error) {
          console.log(error)
        }
      }
    }
  },
  async created () {
    if (!this.enableDashboardBuilder) {
      (async () => {
        try {
          const response = await this.getDashSettings()
          if (response.hasOwnProperty('title')) {
            this.title = response.title
          } else {
            this.title = this.$t('Dashboard')
          }
        } catch (error) {
          console.log(error)
        }
      })()
    }

    if (this.enableDashboardBuilder) {
      try {
        this.isLoading = true
        const widgets = await commonsApi.axiosGetWrapper('/widgets/all?view=dashboard')
        this.widgets = widgets.data.map(el => {
          return {
            id: el?._id,
            component: el?.component,
            name: el?.name,
            properties: el?.properties
          }
        })
        // Obtengo dashboard builder
        const dash = await commonsApi.axiosGetWrapper('/dashboardbuilder/mine')
        if (Object.keys(dash.data).length) {
          this.myWidgets = dash.data.widgets
          this.myDashboardId = dash.data._id
        } else {
          console.log('No hay dashboard')
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
